import styled from "styled-components";

export const ContentContainer = ({
    type = 'primary',
    height = 'auto',
    width = 'auto',
    padding = 'md', paddingBottom, paddingTop, paddingLeft, paddingRight,
    margin = 'none', marginBottom, marginTop, marginLeft, marginRight,
    contentOrientation = 'column', contentGap = 'none',
    contentJustify = 'normal', contentAlign='normal',
    dropShadow = 'none',
    children,
    ...restProps
}) => {    
    const resolvedSpaces = {
        paddingTop: paddingTop ?? padding,
        paddingBottom: paddingBottom ?? padding,
        paddingLeft: paddingLeft ?? padding,
        paddingRight: paddingRight ?? padding,

        marginTop: marginTop ?? margin,
        marginBottom: marginBottom ?? margin,
        marginLeft: marginLeft ?? margin,
        marginRight: marginRight ?? margin,
    };
    
    return (
        <StyledContentContainer
            type={type}
            $width={width}
            $height={height}
            $paddingTop={resolvedSpaces.paddingTop}
            $paddingBottom={resolvedSpaces.paddingBottom}
            $paddingLeft={resolvedSpaces.paddingLeft}
            $paddingRight={resolvedSpaces.paddingRight}

            $marginTop={resolvedSpaces.marginTop}
            $marginBottom={resolvedSpaces.marginBottom}
            $marginLeft={resolvedSpaces.marginLeft}
            $marginRight={resolvedSpaces.marginRight}
            
            $dropShadow={dropShadow}

            $contentOrientation={contentOrientation}
            $contentGap={contentGap}
            $contentJustify={contentJustify}
            $contentAlign={contentAlign}
            {...restProps}
        >
            {children}
        </StyledContentContainer>
    )
} 

const StyledContentContainer = styled.div`
    display: flex;
    filter: ${({theme, $dropShadow}) => $dropShadow === 'lg' ? 'drop-shadow(0 2px 6px rgba(' + theme.colors.neutralSecondaryForegroundRGB+ ', 0.15))'
                                        : $dropShadow === 'md' ? 'drop-shadow(0 4px 4px rgba(' + theme.colors.neutralSecondaryForegroundRGB+ ', 0.15))'
                                        : $dropShadow === 'sm' ? 'drop-shadow(0 2px 2px rgba(' + theme.colors.neutralSecondaryForegroundRGB+ ', 0.15))'
                                        : 'none'};
    flex-direction: ${({$contentOrientation}) => $contentOrientation};
    gap: ${({theme, $contentGap}) => theme.spacing[$contentGap] || 0};
    align-items: ${({$contentAlign}) => $contentAlign};
    justify-content: ${({$contentJustify}) => $contentJustify};

    border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    background-color: ${({theme}) => theme.colors.neutralPrimaryBackground};
    border-radius: ${({theme}) => theme.cornerRadius.lg};

    width: ${({$width}) => $width ? $width : 'auto'};
    height: ${({$height}) => $height ? $height : 'auto'};

    padding-top: ${({ theme, $paddingTop }) => theme.spacing[$paddingTop] || 0};
    padding-bottom: ${({ theme, $paddingBottom }) => theme.spacing[$paddingBottom] || 0};
    padding-left: ${({ theme, $paddingLeft }) => theme.spacing[$paddingLeft] || 0};
    padding-right: ${({ theme, $paddingRight }) => theme.spacing[$paddingRight] || 0};

    margin-top: ${({ theme, $marginTop }) => theme.spacing[$marginTop] || 0};
    margin-bottom: ${({ theme, $marginBottom }) => theme.spacing[$marginBottom] || 0};
    margin-left: ${({ theme, $marginLeft }) => theme.spacing[$marginLeft] || 0};
    margin-right: ${({ theme, $marginRight }) => theme.spacing[$marginRight] || 0};
`